// import React, { useEffect, useState } from 'react';
// import { useDispatch, useSelector } from 'react-redux';
// import { fetchMailBox, updateMailBox ,  } from '../../slices/mailBoxSlice';
// import Pagination from '../../components/Pagination';
// import EditableTable from '../../components/EditableTable';
// import Modal from '../../components/Modal';
// import ChangeLog from '../../components/ChangeLog'; 
// import Loader from "../../components/Loader";
// import AddEmail from "./AddEmail"

// import SimplePagination from "@/components/SimplePagination";
// import PanelUserSearch from "@/components/PanelUserSearch";
// import PageSizeSelector from "@/components/PageSizeSelector";

// const MailBox = () => {
//   const dispatch = useDispatch();
//   const { mailBoxList , status, error  , search , pageSize} = useSelector((state) => state.mailBox);
//   const [currentPage, setCurrentPage] = useState(1);
//   const [editRowId, setEditRowId] = useState(null); // Track which row is in edit mode
//   const [editedData, setEditedData] = useState({}); // Store temporary data for edited row

//   const [searchInput, setSearchInput] = useState(search || "");

//   const itemsPerPage = 10;
//   const indexOfLastItem = currentPage * itemsPerPage;
//   const indexOfFirstItem = indexOfLastItem - itemsPerPage;
//   const currentItems = Array.isArray(mailBoxList.result) ? mailBoxList.result?.slice(indexOfFirstItem, indexOfLastItem) : [];
//   const totalPages = Array.isArray(mailBoxList.result) ? Math.ceil(mailBoxList.result?.length / itemsPerPage) : 0;
//   const editableFields = ['is_read', 'body', 'title', 'status','is_Start','is_Finshed','surveyId','link' ];
//   const [isModalOpen, setIsModalOpen] = useState(false);
//   const [currentLog, setCurrentLog] = useState([]);
//   const openModal = () => setIsModalOpen(true);
//   const closeModal = () => setIsModalOpen(false);

//   // useEffect(() => {
//   //   dispatch(fetchMailBox());
//   // }, [dispatch]);

//   useEffect(() => {
//   dispatch(fetchMailBox({ page: 1, search }));
// }, [dispatch]);

// // Debounced search
// useEffect(() => {
//   const timer = setTimeout(() => {
//     dispatch(fetchMailBox({ page: 1, search: searchInput }));
//   }, 800);

//   return () => clearTimeout(timer);
// }, [searchInput]);

// // Page change
// useEffect(() => {
//   dispatch(fetchMailBox({ page: currentPage, search }));
// }, [currentPage]);


//   useEffect(() => {
//   setSearchInput(search || "");
// }, [search]);

//   const handlePageChange = (page) => {
//     setCurrentPage(page);
//   };
  

//   const handlePageSizeChange = (size) => {
//   dispatch(fetchMailBox({ page: 1, search, pageSize: size }));
// };

//   const handleEdit = (rowId) => {
//     setEditRowId(rowId);
//     const rowData = mailBoxList.result?.find((user) => user.id === rowId);
//     setEditedData(rowData); // Pre-fill the fields with current row data
//   };

//   const handleSave = async () => {
//     // Extract only id, point, and detail for the API call
//     const {id, is_read, body, title ,status, is_Start, is_Finshed, surveyId, link} = editedData;
//     const updatedData = {mailList:[{id, is_read, body, title ,status, is_Start, is_Finshed, surveyId, link}]};
//     await dispatch(updateMailBox(updatedData));
//     dispatch(fetchMailBox());
//     setEditRowId(null); 
//   };

//   const handleCancel = () => {
//     setEditRowId(null); // Exit edit mode and reset data
//     setEditedData({}); // Reset to original data
//   };

//   const handleLog = (id)=>{
//     const logData = mailBoxList?.Change_Log?.filter((f)=> f.id===id)[0]?.oldTrack;
//     setCurrentLog(logData)
//     openModal()
//   }

//   const handleChange = (e, field,val) => {
//     if(field==="active" || field==="status" || field==='is_read' || field==='is_Finshed' || field==='is_Start'){
//       setEditedData((prev) => ({
//         ...prev,
//         [field]:!val,
//       }));
//     }else{
//       setEditedData((prev) => ({
//         ...prev,
//         [field]:e.target.value,
//       }));
//     }
// };



//   const headers = mailBoxList.result?.length > 0 ? Object.keys(mailBoxList.result[0]).filter((key) => key !== 'id') : [];

//   if (status === 'loading') {
//     return <Loader />
//   }

//   // if (status === 'failed') {
//   //   return <div>Error: {error}</div>;
//   // }

//   if (!mailBoxList || mailBoxList.length === 0) {
//     return <div>No data available</div>;
//   }

//   return (
//     <div className="w-full flex items-center flex-col">

//       <PanelUserSearch value={searchInput} onChange={setSearchInput} />

//       <div className='max-w-full'>
//       <EditableTable
//         headers={headers}
//         rows={currentItems}
//         editRowId={editRowId}
//         editedData={editedData}
//         handleEdit={handleEdit}
//         handleSave={handleSave}
//         handleCancel={handleCancel}
//         handleChange={handleChange}
//         handleLog={handleLog}
//         editableFields={editableFields} // Pass editable field
//         hideChangeLog={true}
//       />
//       </div>
      
//   <div className="flex mt-4 items-center justify-between w-11/12">

//   <PageSizeSelector pageSize={pageSize} setPageSize={handlePageSizeChange} />

// {/* <Pagination
//   currentPage={currentPage}
//   setCurrentPage={setCurrentPage}
//   totalPages={totalPages}
// /> */}

// <SimplePagination
//   currentPage={currentPage}
//   setCurrentPage={(page) => dispatch(fetchMailBox({ page, search }))}
//   totalPages={totalPages}
// />


// <button className="activeBtn text-sm text-white  py-1 px-2 rounded" onClick={()=>setIsModalOpen(true)}> Send Email </button>


// </div>

// <Modal
//         isOpen={isModalOpen}
//         onClose={closeModal}
//         title="Send E-Mail"
//         content={<AddEmail />}
//       />

// {/* <Modal
//         isOpen={isModalOpen}
//         onClose={closeModal}
//         title="Change Log"
//         content={<ChangeLog data={currentLog}/>}
//       /> */}
//     </div>
//   );
// };

// export default MailBox;


import React, { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { fetchMailBox, updateMailBox , setPageSize} from '../../slices/mailBoxSlice';
import Loader from "../../components/Loader";
import EditableTable from './SurveyHistoryTable';
import Modal from '../../components/Modal';
import AddEmail from "./AddEmail";
import SimplePagination from "@/components/SimplePagination";
import PanelUserSearch from "@/components/PanelUserSearch";
import PageSizeSelector from "@/components/PageSizeSelector";

const MailBox = () => {
  const dispatch = useDispatch();

  // Redux state
  const { mailBoxList, status, error, search, pageSize } = useSelector((state) => state.mailBox);

  // Local state
  const [currentPage, setCurrentPage] = useState(1); // Current page for pagination
  const [editRowId, setEditRowId] = useState(null); // Track which row is in edit mode
  const [editedData, setEditedData] = useState({}); // Store temporary data for edited row
  const [searchInput, setSearchInput] = useState(search || ""); // Search input for debounced search
  const [isModalOpen, setIsModalOpen] = useState(false); // Modal open/close
  const [currentLog, setCurrentLog] = useState([]); // Change log data if needed

  // Editable fields for table
  const editableFields = ['is_read', 'body', 'title', 'status', 'is_Start', 'is_Finshed', 'surveyId', 'link'];

  // Determine headers dynamically
  const headers = mailBoxList?.result?.length > 0
    ? Object.keys(mailBoxList.result[0]).filter((key) => key !== 'id')
    : [];

  // Determine if data exists
  const hasData = mailBoxList?.result?.length > 0;
  const isSearching = searchInput && searchInput.trim() !== "";
  
  // Calculate total pages for pagination
  const totalPages = hasData
    ? Math.ceil(mailBoxList.result.length / pageSize)
    : 0;

  // =======================
  // Fetch mailbox on mount
  // =======================
  useEffect(() => {
    dispatch(fetchMailBox({ page: 1, search }));
  }, [dispatch]);

  // =======================
  // Sync search input from Redux store
  // =======================
  useEffect(() => {
    setSearchInput(search || "");
  }, [search]);

  // =======================
  // Debounced search effect
  // =======================
  useEffect(() => {
    const timer = setTimeout(() => {
      dispatch(fetchMailBox({ page: 1, search: searchInput }));
    }, 800);

    return () => clearTimeout(timer);
  }, [searchInput, dispatch]);

  // =======================
  // Page change effect
  // =======================
  useEffect(() => {
    dispatch(fetchMailBox({ page: currentPage, search }));
  }, [currentPage, dispatch]);

  // =======================
  // Handlers
  // =======================

  // Open/Close modal
  const openModal = () => setIsModalOpen(true);
  const closeModal = () => setIsModalOpen(false);

  // Handle edit row click
  const handleEdit = (rowId) => {
    setEditRowId(rowId);
    const rowData = mailBoxList.result?.find((item) => item.id === rowId);
    setEditedData(rowData || {});
  };

  // Save edited row
  const handleSave = async () => {
    const { id, is_read, body, title, status, is_Start, is_Finshed, surveyId, link } = editedData;
    const updatedData = {
      mailList: [{ id, is_read, body, title, status, is_Start, is_Finshed, surveyId, link }]
    };

    const resp = await dispatch(updateMailBox(updatedData));
    if (!resp.error) {
      setEditRowId(null);
      dispatch(fetchMailBox({ page: currentPage, search }));
    }
  };

  // Cancel edit
  const handleCancel = () => {
    setEditRowId(null);
    setEditedData({});
  };

  // Handle table input changes
  const handleChange = (e, field, val) => {
    if (['status', 'is_read', 'is_Finshed', 'is_Start'].includes(field)) {
      setEditedData((prev) => ({ ...prev, [field]: !val }));
    } else {
      setEditedData((prev) => ({ ...prev, [field]: e.target.value }));
    }
  };

  // Handle change log modal
  const handleLog = (id) => {
    const logData = mailBoxList?.Change_Log?.find((f) => f.id === id)?.oldTrack || [];
    setCurrentLog(logData);
    openModal();
  };

  // Handle page change from pagination
  const handlePageChange = (page) => setCurrentPage(page);

  // Handle page size change
  const handlePageSizeChange = (size) => {
    dispatch(setPageSize(size)); 
    dispatch(fetchMailBox({ page: 1, search, pageSize: size }));
  };

  // =======================
  // Render loading state
  // =======================
  if (status === 'loading') {
    return (
      <div className="w-full pt-20 flex justify-center">
        <Loader />
      </div>
    );
  }

  // =======================
  // Render no data state
  // =======================
  if (!hasData) {
    return (
      <div className="w-full flex flex-col items-center justify-center py-20 text-gray-500">
        <PanelUserSearch value={searchInput} onChange={setSearchInput} />
        <div className="text-5xl mb-3">🔍</div>
        {searchInput ? (
          <>
            <p className="text-lg font-medium">No results found</p>
            <p className="text-sm mt-1">
              for "<span className="font-semibold">{searchInput}</span>"
            </p>
          </>
        ) : (
          <>
            <p className="text-lg font-medium">No Data Available</p>
            <p className="text-sm mt-1">There are no emails to display</p>
          </>
        )}
      </div>
    );
  }

  // =======================
  // Render main table
  // =======================
  return (
    <div className="w-full flex items-center flex-col">

      {/* Search box */}
      <PanelUserSearch value={searchInput} onChange={setSearchInput} />

      {/* Editable table */}
      <div className="max-w-full mt-4">
        <EditableTable
          headers={headers}
          rows={mailBoxList.result || []}
          editRowId={editRowId}
          editedData={editedData}
          handleEdit={handleEdit}
          handleSave={handleSave}
          handleCancel={handleCancel}
          handleChange={handleChange}
          handleLog={handleLog}
          editableFields={editableFields}
          hideChangeLog={true}
        />
      </div>

      {/* Pagination & Page size selector */}
       {!(isSearching && !hasData) && (
      <div className="flex mt-4 items-center justify-between w-11/12">
        <PageSizeSelector pageSize={pageSize} setPageSize={handlePageSizeChange} />
        <SimplePagination
          currentPage={currentPage}
          setCurrentPage={handlePageChange}
          totalPages={totalPages}
        />
        {/* <button
          className="activeBtn text-sm text-white py-1 px-2 rounded"
          onClick={openModal}
        >
          Send Invites
        </button> */}
      </div>
       )}

      {/* Send Email Modal */}
      <Modal
        isOpen={isModalOpen}
        onClose={closeModal}
        title="Send Invites"
        content={<AddEmail />}
      />
    </div>
  );
};

export default MailBox;